module.exports = __webpack_public_path__ + "static/assets/3a61fe331560a2074fc7b63ae575d6e7.svg";